<div class="pm-title-content"><ng-content></ng-content></div>
<button mat-icon-button (click)="toggleFold()">
  @if (folded) {
    <mat-icon>unfold_more</mat-icon>
  }
  @if (!folded) {
    <mat-icon>unfold_less</mat-icon>
  }
</button>
<button mat-icon-button [mat-dialog-close]="">
  <mat-icon>close</mat-icon>
</button>
